import { SchemaPath, validate } from '@angular/forms/signals';

/**
 * Parses a number string that may use German formatting (e.g. "1.234,56")
 * or standard formatting (e.g. "1234.56"). Returns NaN for malformed input.
 */
function parseNumber(value: string): number {
  const trimmed = value.trim();
  if (!trimmed) return NaN;

  // German format: dots as thousands separators, comma as decimal (e.g. "1.234,56")
  if (trimmed.includes(',')) {
    const normalized = trimmed.replace(/\./g, '').replace(',', '.');
    return Number(normalized);
  }

  return Number(trimmed);
}

export const min = (path: SchemaPath<string>, min: number) => {
  validate(path, ({ value }) => {
    const raw = value();
    if (!raw) return null;

    const parsed = parseNumber(raw);
    if (Number.isNaN(parsed)) return null;

    if (parsed < min) {
      return { kind: 'min', min };
    }
    return null;
  });
};

export const max = (path: SchemaPath<string>, max: number) => {
  validate(path, ({ value }) => {
    const raw = value();
    if (!raw) return null;

    const parsed = parseNumber(raw);
    if (Number.isNaN(parsed)) return null;

    if (parsed > max) {
      return { kind: 'max', max };
    }
    return null;
  });
};
